import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';
import { UsuarioBc } from '../model/usuario-bc';
import { JwtHelper } from '../util/jwt-helper';
import {
  BASE_URL_BARRAMENTO,
  BASE_URL_SCAB_LOGIN,
  CLIENT_ID_BC,
  PASS_SCAB, SECRET_BC,
  URL_BRASIL_CIDADAO, URL_PORTAL_SERVICOS_API, URL_PROXY_BC_TOKEN,
  USER_SCAB
} from "../util/constants";

@Injectable()
export class AuthService {
  tokenScab: any;
  tokenBrasilCidadao: any;
  idTokenBrasilCidadao: any;
  usuarioBrasilCidadao: UsuarioBc;

  constructor(
    private httpClient: HttpClient,
    private storageSercice: StorageService
  ) {
  }

  async logout() {
    this.usuarioBrasilCidadao = null;
    this.tokenBrasilCidadao = null;
    await localStorage.clear();
    await this.logoutBr();
  }

  async logoutBr() {
    const win = window.open(`${URL_BRASIL_CIDADAO}/logout`,
      'null', 'height=10,width=10,status=no, toolbar=no,menubar=no,location=no');

    return new Promise((resolve, reject) => {
      setTimeout(() => {
        win.close();
        resolve({});
      }, 2000);
    });
  }

  getScope() {
    return 'openid+email+profile+govbr_confiabilidades';
  }

  loginBrasilCidadao(redirectUrl) {
    const date = new Date();
    let url = `${URL_BRASIL_CIDADAO}/authorize?response_type=code&client_id=${CLIENT_ID_BC}`;
    url += `&nonce=${date.getTime()}&scope=${this.getScope()}&redirect_uri=` + redirectUrl;
    url = encodeURI(url);
    window.open(url, '_self', 'location=no,clearsessioncache=yes,clearcache=yes');
  }

  getLocalTokenScab() {
    return this.storageSercice.getTokenScab();
  }

  getLocalTokenBarramento() {
    return this.storageSercice.getTokenBarramento();
  }

  getLocalTokenBrasilCidadao() {
    return this.storageSercice.getTokenBc();
  }

  getUsuarioLogado(): UsuarioBc {
    return this.storageSercice.getUserBc();
  }

  existeUsuarioLogado() {
    this.usuarioBrasilCidadao = this.storageSercice.getUserBc();
    if (this.usuarioBrasilCidadao) {
      const dataAtual: any = new Date();
      const dataLogin: any = new Date(this.usuarioBrasilCidadao.dataLogin);
      // o Token do BC expira em uma hora
      const hours = Math.abs(dataAtual - dataLogin) / 36e5;
      // if (!production) {
      return true;
      // } else {
      //   return hours < 0.9;
      // }
    } else {
      return false;
    }
  }

  // @ts-ignore
  async loginScab() {
    const url = `${BASE_URL_SCAB_LOGIN}/login`;
    const user = {
      username: USER_SCAB,
      password: PASS_SCAB
    };
    const result: any = await this.httpClient.post(url, user).toPromise();
    this.tokenScab = result.tokenJwt;
    await this.storageSercice.setTokenScab(this.tokenScab);
    return this.tokenScab;
  }

  async loginBarramento() {
    const url = `${BASE_URL_BARRAMENTO}/login`;
    const user = {
      username: USER_SCAB,
      password: PASS_SCAB
    };
    const result: any = await this.httpClient.post(url, user).toPromise();
    this.tokenScab = result.tokenJwt;
    await this.storageSercice.setTokenBarramento(this.tokenScab);
    return this.tokenScab;
  }

  async getTokenBrasilCidadao(code, urlCallback): Promise<any> {
    const authorization = btoa(`${CLIENT_ID_BC}:${SECRET_BC}`);
    const url = `${URL_PROXY_BC_TOKEN}?code=${code}&url=${urlCallback}`;
    const result: any = await this.httpClient.get(url, {
      headers: {
        Authorization: `Basic ${authorization}`
      }
    }).toPromise();
    return this.processarBrasilCidadao(result);
  }

  async processarBrasilCidadao(result: any) {
    this.tokenBrasilCidadao = result.access_token;
    this.idTokenBrasilCidadao = result.id_token;
    this.storageSercice.setObjLogin(result);
    await this.storageSercice.setTokenBc(this.tokenBrasilCidadao);
    await this.getDadosUsuario();
    return this.tokenBrasilCidadao;
  }

  async getDadosUsuario(): Promise<UsuarioBc> {
    const token: any = JwtHelper.decodeToken(this.idTokenBrasilCidadao);
    this.usuarioBrasilCidadao = {
      cpf: token.sub,
      nome: token.name || 'Nome não encontrado',
      email: token.email || 'Email não encontrado',
      foto: null,
      dataLogin: new Date()
    };
    this.storageSercice.setUserBc(this.usuarioBrasilCidadao);
    return this.usuarioBrasilCidadao;
  }

  async buscarConfiabilidade() {
    const tokenBarramento: any = this.storageSercice.getTokenBarramento();
    const tokenGovBr: any = this.storageSercice.getTokenBc();
    const url = `${URL_PORTAL_SERVICOS_API}/validar-selo-ouro`;
    return this.httpClient.get(url, {
      headers: {
        Authorization: `${tokenBarramento}`,
        AuthorizationSerpro: `${tokenGovBr}`
      }
    }).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts